export const HEADERS = ['HEADER.ID', 'HEADER.NAME', 'HEADER.CREATED'];
